import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Home from "@/pages/Home";
import GuestLogin from "@/pages/GuestLogin";
import VerifyMagic from "@/pages/VerifyMagic";
import Guide from "@/pages/Guide";
import Admin from "@/pages/Admin";
import Poster from "@/pages/Poster";
import Weddings from "@/pages/Weddings";
import ContentEditor from "@/pages/ContentEditor";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center text-[#0E2A47] font-body">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<GuestLogin />} />
            <Route path="/verify" element={<VerifyMagic />} />
            <Route path="/guide" element={<Protected><Guide /></Protected>} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/poster" element={<Poster />} />
            <Route path="/admin/content" element={<ContentEditor />} />
            <Route path="/weddings" element={<Weddings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
